<script>
export default {
  props: {
    pageTitle: String,
    pageSubtitle: Array
  },
  data() {
    return {
      titleFontSize: null
    }
  },
  computed: {
    repeatedSubtitles() {
      let repeatedArray = [];
      let index = 0;

      while (repeatedArray.length < 35) {
        repeatedArray.push(this.pageSubtitle[index % this.pageSubtitle.length]);
        index++;
      }

      return repeatedArray;
    }
  },
  mounted() {
    this.fitTitle();
    window.addEventListener('resize', this.fitTitle);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.fitTitle);
  },
  watch: {
    pageTitle() {
      this.$nextTick(this.fitTitle);
    }
  },
  methods: {
    fitTitle() {
      const el = this.$refs.title;
      if (!el) return;

      // Reset to base size so we measure from a known starting point
      el.style.fontSize = '13vw';

      const containerWidth = el.parentElement.clientWidth * .9;
      const textWidth = el.scrollWidth;
      const currentFontSize = parseFloat(getComputedStyle(el).fontSize);

      const scaledFontSize = (containerWidth / textWidth) * currentFontSize;
      el.style.fontSize = scaledFontSize + 'px';
    }
  }
}
</script>

<template>
  <div class="page-top">
    <h1 class="page-title" ref="title">{{ pageTitle }}</h1>
    <div class="page-subtitle-holder">
      <h2 v-for="(subtitle, index) in repeatedSubtitles"
          :key="index"
          class="page-subtitle">
        {{ subtitle }}
      </h2>
    </div>
  </div>
</template>

<style>
.page-top {
  height: 25vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.page-title {
  font-size: 13vw;
  letter-spacing: -.8vw;
  margin: 0;
  z-index: 1;
  white-space: nowrap;
  display: inline-block;
}

.page-subtitle-holder {
  position: fixed;
  display: flex;
  width: 140%;
  flex-wrap: wrap;
  justify-content: center;
  height: 25vw;
  margin-bottom: 6.5vw;
}

.page-subtitle {
  font-size: 5vw;
  margin: -.3vw .75vw;
  color: #e28b82;
  opacity: .2;
  height: 5vw;
}
</style>